// extracted by mini-css-extract-plugin
module.exports = {"form":"member-operations__RiskForm__form","buttons":"member-operations__RiskForm__buttons"};